import {
  VStack,
  Input,
  Icon,
  InputGroup,
  InputLeftElement,
  Button,
  HStack,
  Text,
} from '@chakra-ui/react'
import { FiSearch } from 'react-icons/fi'
import { useForm } from 'react-hook-form'

import { useQueryParamsContext } from '@/lib/context/queryParams'

interface Props {
  id?: string
}

function PageHeader({ id }: Props): React.ReactElement {
  const { query, setQuery } = useQueryParamsContext()

  const { register, handleSubmit } = useForm({
    defaultValues: {
      search: query['search'],
    },
  })

  return (
    <form
      onSubmit={handleSubmit((values) => {
        setQuery('search', values.search)
      })}
    >
      <VStack
        spacing={{
          base: 4,
          md: 10,
        }}
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          backgroundImage: 'url("/images/blogs/hero.jpg")',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          color: 'white',
          h: {
            base: '200px',
            sm: '300px',
            md: '356px',
          },
        }}
      >
        <Text
          as="h1"
          sx={{
            fontWeight: 'medium',
            fontSize: {
              base: '2xl',
              sm: '3.5xl',
              md: '5xl',
            },
          }}
        >
          PDPA Core Blogs
        </Text>
        <HStack
          id={id}
          spacing={{ base: 2, sm: 4 }}
          layerStyle="container"
          sx={{
            maxW: '612px',
            w: 'full',
            h: {
              base: 10,
              md: 14,
            },
            py: '0 !important',
          }}
        >
          <InputGroup sx={{ h: 'full' }}>
            <InputLeftElement pointerEvents="none" sx={{ h: 'full' }}>
              <Icon
                as={FiSearch}
                boxSize={{
                  base: 4,
                  md: 5,
                }}
                sx={{
                  color: 'gray.400',
                }}
              />
            </InputLeftElement>
            <Input
              type="search"
              placeholder="ค้นหาเนื้อหาที่เกี่ยวข้อง"
              sx={{
                borderRadius: 'base',
                fontWeight: 'normal',
                _placeholder: {
                  fontWeight: 'normal',
                },
                h: 'full',
              }}
              {...register('search')}
            />
          </InputGroup>
          <Button
            sx={{ h: 'full', minW: { base: 16, sm: 20 }, borderRadius: 'md' }}
            type="submit"
          >
            ค้นหา
          </Button>
        </HStack>
      </VStack>
    </form>
  )
}

export default PageHeader
